import React from 'react';

const ChatBotUnavailable = (props) => (
  <svg
    width="56"
    height="48"
    viewBox="0 0 56 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M48 17.75V12.75C48 10 45.75 7.75 43 7.75H35.5C35.5 3.6 32.15 0.25 28 0.25C23.85 0.25 20.5 3.6 20.5 7.75H13C10.25 7.75 8 10 8 12.75V17.75C3.85 17.75 0.5 21.1 0.5 25.25C0.5 29.4 3.85 32.75 8 32.75V42.75C8 45.5 10.25 47.75 13 47.75H43C45.75 47.75 48 45.5 48 42.75V32.75C52.15 32.75 55.5 29.4 55.5 25.25C55.5 21.1 52.15 17.75 48 17.75ZM43 42.75H13V12.75H43V42.75ZM20.5 27.75C18.425 27.75 16.75 26.075 16.75 24C16.75 21.925 18.425 20.25 20.5 20.25C22.575 20.25 24.25 21.925 24.25 24C24.25 26.075 22.575 27.75 20.5 27.75ZM39.25 24C39.25 26.075 37.575 27.75 35.5 27.75C33.425 27.75 31.75 26.075 31.75 24C31.75 21.925 33.425 20.25 35.5 20.25C37.575 20.25 39.25 21.925 39.25 24ZM18 32.75H38V37.75H18V32.75Z"
      fill="#495A67"
      fillOpacity="0.24"
    />
  </svg>
);

export default ChatBotUnavailable;
